module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-allorderbill"
  }, [_c('navbar', {
    attrs: {
      "title": "单据统计-机构"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "common-scroll"
  }, _vm._l((_vm.billCountDetails), function(billCountDetail) {
    return _c('div', {
      staticClass: "list-container"
    }, [(_vm.hasAlpha(billCountDetail.phonetic)) ? _c('p', {
      staticClass: "letter-flag",
      attrs: {
        "id": billCountDetail.phonetic
      }
    }, [_vm._v(_vm._s(billCountDetail.phonetic))]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "ui-listview",
      staticStyle: {
        "padding-bottom": "0"
      }
    }, [_c('li', {
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/bill-count-serial',
          query: {
            restaurant_id: _vm.queryData.restaurant_id,
            bill_state: _vm.queryData.bill_state,
            start_date: _vm.queryData.start_date,
            end_date: _vm.queryData.end_date,
            organ_id: billCountDetail.organ_id,
            organ_type: billCountDetail.organ_type
          }
        }
      }
    }, [_c('p', {
      staticClass: "allorderbill-list-p"
    }, [_vm._v(_vm._s(_vm.queryData.restaurant_name) + " - " + _vm._s(billCountDetail.organ_name))]), _vm._v(" "), _c('ul', {
      staticClass: "ui-detail-listview ui-billcount-detail-listview"
    }, [_c('li', [_vm._v("订货金额：" + _vm._s(billCountDetail.order_bill_money) + "元")]), _vm._v(" "), _c('li', [_vm._v("实收金额: " + _vm._s(billCountDetail.sum_money_recipient) + "元")]), _vm._v(" "), _c('li', [_vm._v("订货单：共" + _vm._s(billCountDetail.order_bill_num) + "张")]), _vm._v(" "), _c('li', [_vm._v("发货金额：" + _vm._s(billCountDetail.deliver_money) + "元")]), _vm._v(" "), _c('li', [_vm._v("退货单：共" + _vm._s(billCountDetail.reverse_bill_num) + "张")]), _vm._v(" "), _c('li', [_vm._v("退货金额：" + _vm._s(billCountDetail.reverse_money) + "元")]), _vm._v(" "), _c('li', [_vm._v("发货减实收：" + _vm._s(_vm._f("filterFloat")((billCountDetail.deliver_money - billCountDetail.sum_money_recipient))) + "元")]), _vm._v(" "), _c('li', [_vm._v("实收减退货：" + _vm._s(_vm._f("filterFloat")((billCountDetail.sum_money_recipient - billCountDetail.reverse_money))) + "元")])])])], 1)])])
  }), 0), _vm._v(" "), _c('get-total', {
    attrs: {
      "filter": _vm.queryData,
      "href": "/cldEdi/business/getTotalByRestaurantId",
      "name": "机构"
    }
  }), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "letter-ullist"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.letters), function(letter, index) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.anchor(letter)
      }
    }, [_vm._v(_vm._s(letter))])])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "##"
    }
  }, [_vm._v("#")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e6f2298!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BillCountDetail.vue
// module id = 608
// module chunks = 1